<div *ngIf="meeting" class="meeting-mini-card">
  <div class="header">
    <div class="cover-wrap">
      <img *ngIf="coverImgUrl" [src]="coverImgUrl" [alt]="" class="cover">
    </div>
    <div class="meta">
      <span class="subject bold">{{ subject }}</span>
      <h2 class="title bold">{{ title }}</h2>
    </div>
  </div>
  <div class="info">
    <div class="info-item">
      <span class="label normal">{{ 'library.meeting-card.date' | customLocale }}</span>&nbsp;
      <span class="label normal value">{{ meetingDate | dfnsFormat: 'dd MMMM yyyy HH:mm' }}</span>
    </div>

    <div class="info-item">
      <span class="label normal">{{ 'library.meeting-card.types.' + type | customLocale }}</span>&nbsp;
      <span class="label normal value">{{ group }}</span>
    </div>

    <div class="info-item">
      <span class="label normal">{{ 'library.meeting-card.participation' | customLocale }}</span>&nbsp;
      <span class="label normal value">{{ price ? price : 'library.meeting-card.free' | customLocale }}</span>
    </div>
  </div>
  <div class="footer">
    <on-ui-button label="library.meeting-card.detailed"
                  class="primary outline"
                  (onclick)="openModal($event)">
    </on-ui-button>
  </div>
</div>
